import type { FunctionComponent } from 'react';
import { Children } from 'react';

import {
    GroupContainer,
    GroupContent,
    GroupLabel,
    ItemsContainer,
    TimelineDot,
    TimelineLine,
    TimelineVisual,
} from './timeline-styles';
import type { TimelineGroupProps } from './timeline-types';

export const TimelineGroup: FunctionComponent<TimelineGroupProps> = ({
    children,
    className,
    contentClassName,
    itemsClassName,
    itemsRef,
    isLastGroup = false,
    label,
    showTimeline = true,
}) => {
    // A last group with no items has nothing below its dot to connect to.
    const showsLine = !isLastGroup || Children.count(children) > 0;

    return (
        <GroupContainer className={className}>
            {showTimeline ? (
                <TimelineVisual>
                    <TimelineDot />
                    {showsLine ? <TimelineLine isLastGroup={isLastGroup} /> : null}
                </TimelineVisual>
            ) : null}
            <GroupContent className={contentClassName}>
                <GroupLabel>{label}</GroupLabel>
                <ItemsContainer ref={itemsRef} className={itemsClassName}>
                    {children}
                </ItemsContainer>
            </GroupContent>
        </GroupContainer>
    );
};
